import cross from '../assets/icon/cross_filters.svg'
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

function ActiveFilters({ currentFilters, setCurrentFilters, customizeToggle,setCustomizeToggle }) {

    const deleteFilter = (key, value) => {
        const newFilters = {...currentFilters};
        if (newFilters[key]) {
            newFilters[key] = newFilters[key].filter(item => item !== value);
        }
        if (newFilters[key] && newFilters[key].length === 0) {
            delete newFilters[key];
        }
        setCurrentFilters(newFilters);
    }
    return ( 
    <div className="active-filters" style={((!currentFilters && !customizeToggle) || (!customizeToggle && currentFilters && Object.keys(currentFilters).length === 0)) ? {display: 'none'} : {}}>
        <div className="active-filters_container">
            {(currentFilters && Object.keys(currentFilters).length > 0) ? (
                <>
                {Object.keys(currentFilters).map((key) => (
                    currentFilters[key].map((value, index) => (
                        <Tooltip title={`${value}`} TransitionComponent={Zoom}>
                            <div key={index} className="active-filters_item">
                                <span>{key} : {value}</span>
                                <img src={cross} onClick={() => deleteFilter(key, value)} className='verti_center'/>
                            </div>
                        </Tooltip>
                    ))
                ))}
                </>
            ) : (<></>)}

            {customizeToggle && 
                <Tooltip title={`Customizable`} TransitionComponent={Zoom}>
                    <div className="active-filters_item">
                        <span>Customizable</span>
                        <img src={cross} onClick={() => setCustomizeToggle(!customizeToggle)} className='verti_center'/>
                    </div>
                </Tooltip>
            }
        </div>
    </div> );
}

export default ActiveFilters;